import { useLockBodyScroll } from "@/hooks/useLockBodyScroll";
import { cn } from "@/lib/utils";
import { AnimatePresence, HTMLMotionProps, motion } from "framer-motion";
import { ReactNode } from "react";
import { zIndex } from "styles/zIndex";

export const MixModal = ({
    children,
    style,
    isOpen,
    onRequestClose,
    className,
    ...props
}: Omit<HTMLMotionProps<"div">, "children"> & {
    children?: ReactNode;
    isOpen: boolean;
    onRequestClose?: () => void;
}) => {
    const MotionDiv = motion.div as any;
    const AnimatePresenceComponent = AnimatePresence as any;

    useLockBodyScroll(isOpen);

    return (
        <AnimatePresenceComponent>
            {isOpen && (
                <MotionDiv
                    style={style}
                    className={cn(
                        `fixed inset-0 z-[103] flex w-full items-center
                        justify-center bg-black/50`,
                        className
                    )}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    {...props}
                >
                    <div
                        className="absolute inset-0 -z-10"
                        onClick={onRequestClose}
                    />
                    {children}
                </MotionDiv>
            )}
        </AnimatePresenceComponent>
    );
};
